'use client'

import { useMemo } from 'react'
import { useModel } from '../hooks/useModel'
import * as THREE from 'three/webgpu'
import { useNodeMaterials } from '../hooks/useNodeMaterials'

export function Casino(props) {
  const { nodes, materials } = useModel('/models/casino.glb')
  const { getMat } = useNodeMaterials(materials)

  // Casino_Baked: the bake is stored as emissiveMap with color=(0,0,0).
  // Use the emissiveMap as the diffuse map instead.
  const casinoBakedMat = useMemo(() => {
    const origMat = nodes.Casino_Baked?.material
    if (!origMat) return null
    const mat = new THREE.MeshStandardNodeMaterial()
    mat.map = origMat.emissiveMap
    mat.color = new THREE.Color('white')
    mat.roughness = 1
    mat.metalness = 0
    mat.side = THREE.DoubleSide
    return mat
  }, [nodes.Casino_Baked])

  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.Warehouse04.geometry}
        material={getMat(nodes.Warehouse04)}
        position={[44.073, 0, 27.295]}
        rotation={[0, -1.571, 0]}
        scale={0.013}
        castShadow
        receiveShadow
      />
      <mesh
        geometry={nodes.Casino_Baked.geometry}
        material={casinoBakedMat}
        castShadow
        receiveShadow
      />
    </group>
  )
}

